import { InjectionToken } from '@angular/core';

import { Ampli, ampli } from './wrapper';

export const AMPLI = new InjectionToken<Ampli>('An abstraction over the ampli wrapper', {
  factory: (): Ampli => ampli
});
